import { createSlice } from '@reduxjs/toolkit';
import type { AsyncStatus } from '@/shared/types/asyncState';
import { fetchPlataformaEmbedUrl } from './actions';

interface PlataformaEmbedUrlState {
  embedUrl: string | null;
  loading: boolean;
  error: string | null;
  status: AsyncStatus;
}

const initialState: PlataformaEmbedUrlState = {
  embedUrl: null,
  loading: false,
  error: null,
  status: 'idle',
};

const plataformaEmbedUrlSlice = createSlice({
  name: 'plataformaEmbedUrl',
  initialState,
  reducers: {
    resetPlataformaEmbedUrl: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlataformaEmbedUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(fetchPlataformaEmbedUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.embedUrl = action.payload.embedUrl;
        state.status = 'success';
      })
      .addCase(fetchPlataformaEmbedUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
      });
  },
});

export const { resetPlataformaEmbedUrl } = plataformaEmbedUrlSlice.actions;
export const plataformaEmbedUrlReducer = plataformaEmbedUrlSlice.reducer;
